/**
 * Official launch months (TMMPDM-0037, tmm-api 0100): a launch is the 1st of a month after today,
 * UTC. Today's month is never offered — even on the 1st, today is not "after today" — so the list
 * starts at next month (UTC) and runs `count` months on. Values are ISO dates, the 1st.
 */
export const LAUNCH_MONTHS_OFFERED = 24;

export function launchMonthOptions(
  today: Date = new Date(),
  count = LAUNCH_MONTHS_OFFERED,
): string[] {
  const year = today.getUTCFullYear();
  const month = today.getUTCMonth();
  return Array.from({ length: count }, (_, i) => {
    const date = new Date(Date.UTC(year, month + 1 + i, 1));
    const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
    return `${date.getUTCFullYear()}-${mm}-01`;
  });
}
